import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/edit',
    name: 'edit',
    component: () => import('../views/edit/Index.vue')
  },
  {
    path: '/DaylyOrderStatistic',
    name: 'DaylyOrderStatistic',
    component: () => import('../views/DaylyOrderStatistic.vue')
  }

]

const router = new VueRouter({
  routes
})

export default router
